import React from "react";
import {
  Button,
  DropDown,
  Panel,
  MinimalArrowIcon,
  Spinner,
} from "dab-component-lib";
import { graphql, compose } from "react-apollo";
import { withRouter } from "react-router";
import _ from "lodash";
import I18n from "../../../I18n/I18n";
import {
  availableSiteLanguages,
  availableCurrencies,
  currentUserQuery,
} from "../../../queries";
import axios from "axios";
import { GETBASKETS } from "../../../utils/constants";
import { LoadingStyle } from "../../../utils/style-utils";
import {
  AbsoluteContainerStyle,
  LoginPanelWrapperStyle,
  UserPanelWrapperStyle,
  InLineContainerStyle,
  LabelStyle,
} from "./style";

class UserMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      baskets: [],
    };
  }

  componentDidMount() {
    let uid = localStorage.getItem("currentUid");
    axios.get(`${GETBASKETS}/${uid}`).then((basketsApi) => {
      this.setState({ baskets: basketsApi.data.slice() });
    });
  }

  userSettings = async (setting, props) => {
    const { value, index } = props;
    localStorage.setItem(setting, value);
    localStorage.setItem(`${setting}Index`, index);
    this.setState({ [setting]: value });
    window.location.reload();
  };

  basketHandler() {
    const {
      currentUserQuery: { loading, error, currentUserContext },
    } = this.props;
    if (!loading && !error) {
      let role = _.find(
        currentUserContext.roles,
        (role) => role.targetId === "shop_administrator"
      );
      if (role) {
        return this.state.baskets.map((basket) => {
          switch (basket[1].basket_type) {
            case "d_training": {
              return (
                <div>
                  <InLineContainerStyle background>
                    <LabelStyle>
                      {I18n.t("menu.totalAnnual")} D-Training:
                    </LabelStyle>
                    <LabelStyle bold>{basket[2].totalamount} €</LabelStyle>
                  </InLineContainerStyle>
                  <InLineContainerStyle background>
                    <LabelStyle>
                      {I18n.t("menu.totalActual")} D-Training:
                    </LabelStyle>
                    <LabelStyle bold>{basket[3].amount} €</LabelStyle>
                  </InLineContainerStyle>
                </div>
              );
            }
            case "business_area_budget": {
              return (
                <div>
                  <InLineContainerStyle background>
                    <LabelStyle>
                      {I18n.t("menu.totalAnnual")} Area Export:
                    </LabelStyle>
                    <LabelStyle bold>{basket[2].totalamount} €</LabelStyle>
                  </InLineContainerStyle>
                  {basket[4].cobranding > 0 && (
                    <InLineContainerStyle background>
                      <LabelStyle>Co-branding Area Export:</LabelStyle>
                      <LabelStyle bold>{basket[4].cobranding} €</LabelStyle>
                    </InLineContainerStyle>
                  )}
                  <InLineContainerStyle background>
                    <LabelStyle>
                      {I18n.t("menu.totalActual")} Area Export:
                    </LabelStyle>
                    <LabelStyle bold>{basket[3].amount} €</LabelStyle>
                  </InLineContainerStyle>
                </div>
              );
            }
            case "admin_budget": {
              return (
                <div>
                  <InLineContainerStyle background>
                    <LabelStyle>{I18n.t("menu.totalAnnual")} DAB:</LabelStyle>
                    <LabelStyle bold>{basket[2].totalamount} €</LabelStyle>
                  </InLineContainerStyle>
                  {basket[4].cobranding > 0 && (
                    <InLineContainerStyle background>
                      <LabelStyle>Co-branding DAB:</LabelStyle>
                      <LabelStyle bold>{basket[4].cobranding} €</LabelStyle>
                    </InLineContainerStyle>
                  )}
                  <InLineContainerStyle background>
                    <LabelStyle>{I18n.t("menu.totalActual")} DAB:</LabelStyle>
                    <LabelStyle bold>{basket[3].amount} €</LabelStyle>
                  </InLineContainerStyle>
                </div>
              );
            }
            default: {
              if (basket[0].id !== "TBD") {
                return (
                  <div>
                    <InLineContainerStyle background>
                      <LabelStyle>{I18n.t("menu.totalAnnual")}:</LabelStyle>
                      <LabelStyle bold>{basket[2].totalamount} €</LabelStyle>
                    </InLineContainerStyle>
                    {basket[4].cobranding > 0 && (
                      <InLineContainerStyle background>
                        <LabelStyle>Co-branding:</LabelStyle>
                        <LabelStyle bold>{basket[4].cobranding} €</LabelStyle>
                      </InLineContainerStyle>
                    )}
                    <InLineContainerStyle background>
                      <LabelStyle>Co-branding:</LabelStyle>
                      <LabelStyle bold>{basket[4].cobranding} €</LabelStyle>
                    </InLineContainerStyle>
                    <InLineContainerStyle background>
                      <LabelStyle>{I18n.t("menu.totalActual")}:</LabelStyle>
                      <LabelStyle bold>{basket[3].amount} €</LabelStyle>
                    </InLineContainerStyle>
                  </div>
                );
              }
              return <span />;
            }
          }
        });
      } else {
        return currentUserContext.fieldBasketReference.map((basket, i) => {
          return (
            <div key={i}>
              <InLineContainerStyle background>
                <LabelStyle>{I18n.t("menu.totalAnnual")}:</LabelStyle>
                <LabelStyle bold>
                  {basket.entity.fieldBasketTotalAmount} €
                </LabelStyle>
              </InLineContainerStyle>
              {basket.entity.fieldBasketCoBranding > 0 && (
                <InLineContainerStyle background>
                  <LabelStyle>Co-branding:</LabelStyle>
                  <LabelStyle bold>
                    {basket.entity.fieldBasketCoBranding} €
                  </LabelStyle>
                </InLineContainerStyle>
              )}
              <InLineContainerStyle background>
                <LabelStyle>{I18n.t("menu.totalActual")}:</LabelStyle>
                <LabelStyle bold>
                  {basket.entity.fieldBasketAmount} €
                </LabelStyle>
              </InLineContainerStyle>
            </div>
          );
        });
      }
    }
  }

  render() {
    const {
      onLogin,
      onSignUp,
      onLogout,
      onOrders,
      onEditProfile,
      currentUserQuery: { currentUserContext },
      availableSiteLanguages,
      availableCurrencies,
      onClose,
    } = this.props;
    let languages = [];
    let currencies = [];
    let defaultLanguage = null;
    let defaultCurrency = null;
    if (!availableSiteLanguages.loading && !availableSiteLanguages.error) {
      availableSiteLanguages.availableLanguages.forEach((language, index) => {
        if (language.isDefault) {
          localStorage.setItem("defaultLanguage", language.id);
          defaultLanguage = index;
        }
        languages.push({
          label: language.name,
          value: language.id,
        });
      });
    }

    if (!availableCurrencies.loading && !availableCurrencies.error) {
      availableCurrencies.nodeQuery.entities.forEach((currency, index) => {
        if (currency.title === "EUR") {
          localStorage.setItem("defaultCurrency", currency.nid);
          defaultCurrency = index;
        }
        currencies.push({
          label: currency.title,
          value: currency.nid,
        });
      });
    }

    return (
      <AbsoluteContainerStyle>
        {currentUserContext && (
          <div>
            {currentUserContext.uid === 0 ? (
              <LoginPanelWrapperStyle>
                <Panel size="L" skin="neutral" title="" onClose={onClose}>
                  <div>
                    <Button
                      autoWidth={false}
                      disabled={false}
                      expanded={false}
                      icon={null}
                      id="login"
                      label="Login"
                      onClick={onLogin}
                      onMouseEnter={function () {}}
                      onMouseLeave={function () {}}
                      outline={false}
                      size="M"
                    />
                    <Button
                      autoWidth={false}
                      disabled={false}
                      expanded={false}
                      icon={null}
                      id="signup"
                      label={I18n.t("menu.signUp")}
                      onClick={() =>
                        onSignUp(
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : localStorage.getItem("defaultLanguage")
                        )
                      }
                      onMouseEnter={function () {}}
                      onMouseLeave={function () {}}
                      outline={false}
                      size="M"
                    />
                  </div>
                </Panel>
              </LoginPanelWrapperStyle>
            ) : (
              <UserPanelWrapperStyle>
                <Panel
                  action={{
                    label: "Logout",
                    onClick: onLogout,
                  }}
                  size="L"
                  skin="neutral"
                  title={currentUserContext.name}
                  onClose={onClose}
                >
                  {availableSiteLanguages.availableLanguages &&
                  availableCurrencies.nodeQuery ? (
                    <div>
                      {!_.find(
                        currentUserContext.roles,
                        (role) =>
                          role.targetId === "visitor_filial" ||
                          role.targetId === "visitor_customer"
                      ) && (
                        <InLineContainerStyle onClick={onOrders}>
                          <LabelStyle>{I18n.t("menu.myOrders")}</LabelStyle>
                          <MinimalArrowIcon
                            color="#004615"
                            orientation="right"
                            size={20}
                          />
                        </InLineContainerStyle>
                      )}
                      {this.basketHandler()}
                      <InLineContainerStyle>
                        <DropDown
                          disabled={false}
                          expanded
                          id="language-select"
                          label={I18n.t("menu.language")}
                          onChange={(props) =>
                            this.userSettings("language", props)
                          }
                          options={languages}
                          placeholder={I18n.t("menu.selectLanguage")}
                          selectedIndex={
                            localStorage.getItem("languageIndex")
                              ? localStorage.getItem("languageIndex")
                              : defaultLanguage
                          }
                          size="S"
                          skin="secondary"
                        />
                      </InLineContainerStyle>
                      {!_.find(
                        currentUserContext.roles,
                        (role) => role.targetId === "visitor_customer"
                      ) && (
                        <InLineContainerStyle>
                          <DropDown
                            disabled={false}
                            expanded
                            label={I18n.t("menu.showPrices")}
                            id="show-prices"
                            onChange={(props) =>
                              this.userSettings("showPrices", props)
                            }
                            options={[
                              {
                                label: "Sì",
                                value: true,
                              },
                              {
                                label: "No",
                                value: false,
                              },
                            ]}
                            placeholder={I18n.t("menu.select")}
                            selectedIndex={
                              localStorage.getItem("showPricesIndex")
                                ? localStorage.getItem("showPricesIndex")
                                : 0
                            }
                            size="S"
                            skin="secondary"
                          />
                        </InLineContainerStyle>
                      )}
                      {!_.find(
                        currentUserContext.roles,
                        (role) => role.targetId === "visitor_customer"
                      ) && (
                        <InLineContainerStyle>
                          <DropDown
                            disabled={false}
                            expanded
                            label={I18n.t("menu.selectCurrency")}
                            id="currency-select"
                            onChange={(props) =>
                              this.userSettings("currency", props)
                            }
                            options={currencies}
                            placeholder={I18n.t("menu.selectCurrency")}
                            selectedIndex={
                              localStorage.getItem("currencyIndex")
                                ? localStorage.getItem("currencyIndex")
                                : defaultCurrency
                            }
                            size="S"
                            skin="secondary"
                          />
                        </InLineContainerStyle>
                      )}
                      <InLineContainerStyle>
                        <Button
                          expanded
                          icon="EditIcon"
                          iconOrientation="top"
                          id="profile_button"
                          label={I18n.t("menu.editProfile")}
                          onClick={() =>
                            onEditProfile(
                              localStorage.getItem("language")
                                ? localStorage.getItem("language")
                                : localStorage.getItem("defaultLanguage")
                            )
                          }
                          size="S"
                        />
                      </InLineContainerStyle>
                    </div>
                  ) : (
                    <LoadingStyle small>
                      <Spinner size={100} />
                    </LoadingStyle>
                  )}
                </Panel>
              </UserPanelWrapperStyle>
            )}
          </div>
        )}
      </AbsoluteContainerStyle>
    );
  }
}

export default compose(
  graphql(availableSiteLanguages, {
    name: "availableSiteLanguages",
  }),
  graphql(availableCurrencies, {
    name: "availableCurrencies",
    options: (props) => ({
      variables: {
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(currentUserQuery, {
    name: "currentUserQuery",
    options: { fetchPolicy: "network-only" },
  })
)(withRouter(UserMenu));



// WEBPACK FOOTER //
// ./src/components/common/userMenu/index.js